import { render, staticRenderFns } from "./journalDetails.vue?vue&type=template&id=6adde738&scoped=true&"
import script from "./journalDetails.vue?vue&type=script&lang=js&"
export * from "./journalDetails.vue?vue&type=script&lang=js&"
import style0 from "./journalDetails.vue?vue&type=style&index=0&id=6adde738&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adde738",
  null
  
)

export default component.exports